/**
 * Checkout Yampi no tema Hi Beauty.
 *
 * O script oficial da Yampi (snippets/YampiSnippet.liquid) só troca o botão na
 * página /cart. Este arquivo leva para a Yampi também:
 *   - o "Finalizar compra" do carrinho lateral (e da página do carrinho);
 *   - o botão "Comprar agora" da página de produto (blocks/hi-buy-now.liquid).
 * Se a Yampi não responder ou estiver desativada, segue para o checkout da
 * Shopify — a cliente nunca fica presa.
 */
const API = 'https://api.dooki.com.br/v2/public/shopify/cart';
const config = window.hiYampi || {};
const CHECKOUT_SELECTOR =
  'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href$="/checkout"]';

const yampiInstalled = () => config.enabled && 'yampiCheckoutUrl' in window;

function loader(show) {
  const el = document.querySelector('.yampi-loader');
  if (el) el.style.display = show ? 'block' : 'none';
}

function withUtms(url) {
  return typeof window.ymp_getUrlWithUtms === 'function' ? window.ymp_getUrlWithUtms(url) : url;
}

let busy = false;

/** Manda o carrinho atual para a Yampi e redireciona para o checkout dela. */
export async function goToCheckout() {
  if (busy) return;
  busy = true;

  if (!yampiInstalled()) {
    window.location.href = '/checkout';
    return;
  }

  loader(true);
  const fallback = setTimeout(() => (window.location.href = '/checkout'), 10000);

  try {
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const response = await fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        shop: window.location.host,
        shopify_internal_domain: config.domain,
        cart_payload: cart,
      }),
    });
    const data = await response.json();

    if (data && data.active && data.checkout_direct_url) {
      clearTimeout(fallback);
      window.location.href = withUtms(data.checkout_direct_url);
      return;
    }
  } catch (error) {
    console.warn('[hi-yampi] Checkout Yampi indisponível, seguindo para o checkout da Shopify.', error);
  }

  clearTimeout(fallback);
  window.location.href = '/checkout';
}

/** Adiciona o produto do formulário ao carrinho e vai direto para o checkout. */
export async function buyNow(form) {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { Accept: 'application/json' },
    body: new FormData(form),
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.description || error.message || 'Não foi possível adicionar ao carrinho.');
  }
  await goToCheckout();
}

// "Finalizar compra" em qualquer lugar (carrinho lateral, página do carrinho).
document.addEventListener(
  'click',
  (event) => {
    const el = event.target.closest?.(CHECKOUT_SELECTOR);
    if (!el || el.classList.contains('ymp_elem_mainBtn') || el.disabled || !yampiInstalled()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    goToCheckout();
  },
  true
);

document.addEventListener(
  'submit',
  (event) => {
    if (event.submitter?.name !== 'checkout' || !yampiInstalled()) return;
    event.preventDefault();
    goToCheckout();
  },
  true
);

// Botões "Comprar agora" (blocks/hi-buy-now.liquid).
class HiBuyNow extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.error = this.querySelector('.hi-buy-now__error');
    this.button?.addEventListener('click', () => this.buy());
  }

  async buy() {
    const form = document.getElementById(this.dataset.form);
    if (!form || this.button.disabled) return;
    this.button.disabled = true;
    this.button.setAttribute('aria-busy', 'true');
    if (this.error) this.error.hidden = true;
    try {
      await buyNow(form);
    } catch (error) {
      loader(false);
      busy = false;
      this.button.disabled = false;
      this.button.removeAttribute('aria-busy');
      if (this.error) {
        this.error.textContent = error.message;
        this.error.hidden = false;
      }
    }
  }
}

if (!customElements.get('hi-buy-now')) customElements.define('hi-buy-now', HiBuyNow);
